// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i9tu","tabsBox":"styles_tabsBox__2tEIR","createButton":"styles_createButton__tV7fV"};